import Categories from './ContactUsCategories.json';
import JsonConfigUtils from '../form/FormConfigUtils';

const areValidCategories = (category, subcategory) =>
  JsonConfigUtils.areValidCategories(Categories, category, subcategory);

const getSubCategories = value => JsonConfigUtils.getSubCategories(Categories, value);

const getCustomFields = (category, subcategory) =>
  JsonConfigUtils.getCustomFields(Categories, category, subcategory);

const getAboveCustomFields = (category, subcategory) =>
  JsonConfigUtils.getAboveCustomFields(Categories, category, subcategory);

export default { getCustomFields, getAboveCustomFields, getSubCategories, areValidCategories };



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/ContactUsUtils.js
 **/